import { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { gsap, Elastic, Power1 } from 'gsap'

import menu from './psmenu'
import style from './header.module.css'

const ProServiceMenu = (props) => {
  const parentEle = useRef()
  const [parentHeight, setHeight] = useState(400)
  const [awstl] = useState(gsap.timeline({ paused: true }))
  const [gcptl] = useState(gsap.timeline({ paused: true }))
  const [azuretl] = useState(gsap.timeline({ paused: true }))

  const getIcon = (desc) => {
    switch (desc) {
      case 'Cloud Migration':
        return (
          <img
            src="/images/clouds/nav/migration.png"
            alt="Cloud Migration"
            className={style.cloudIconNav}
          />
        )

      case 'Big Data & Analytics':
        return (
          <img src="/images/clouds/nav/bigdata.png" alt="Big Data" className={style.cloudIconNav} />
        )

      case 'Cost Optimization':
        return (
          <img
            src="/images/clouds/nav/costop.png"
            alt="Cost Optimization"
            className={style.cloudIconNav}
          />
        )

      case 'Application Modernization':
        return (
          <img
            src="/images/clouds/nav/devops.png"
            alt="DevOps Automation"
            className={style.cloudIconNav}
          />
        )

      case 'Security & Compliance':
        return (
          <img
            src="/images/clouds/nav/securitycomp.png"
            alt="Cloud Security"
            className={style.cloudIconNav}
          />
        )

      default:
        return ''
    }
  }

  useEffect(() => {
    awstl.fromTo('.awsarrow', { x: 0 }, { x: 5, repeat: -1, yoyo: true })

    gcptl.fromTo('.gcparrow', { x: 0 }, { x: 5, repeat: -1, yoyo: true })

    azuretl.fromTo('.azurearrow', { x: 0 }, { x: 5, repeat: -1, yoyo: true })
  }, [])

  const awsbutton = (action) => {
    if ('play' === action) {
      awstl.play()
    } else {
      awstl.pause()
    }
  }

  const gcpbutton = (action) => {
    if ('play' === action) {
      gcptl.play()
    } else {
      gcptl.pause()
    }
  }

  const azurebutton = (action) => {
    if ('play' === action) {
      azuretl.play()
    } else {
      azuretl.pause()
    }
  }
  useEffect(() => {
    setTimeout(() => {
      // const parentWidth = parentEle.current.parentElement.getBoundingClientRect().width
      setHeight(props.parenth * 0.75)
      gsap.to(`.${style.navboxleft}`, {
        duration: 0.25,
        width: props.parentw * 0.7,
        ease: Power1.easeOut,
      })
      gsap.fromTo(
        `.${style.laserdivide}`,
        { opacity: 0, rotate: -5, x: -550 },
        {
          x: props.parentw * 0.35,
          y: props.parenth * 0.1,
          duration: 1,
          position: 'absolute',
          opacity: 0.5,
          rotate: 0,
          ease: Elastic.easeOut.config(1, 0.9),
        }
      )
      gsap.fromTo(
        `.${style.cloudItem}`,
        { x: -550, opacity: 0 },
        {
          x: 0,
          y: 20,
          opacity: 1,
          duration: 1.5,
          stagger: 0.1,
          delay: 0.1,
          ease: Elastic.easeOut.config(1, 0.9),
        }
      )
      gsap.fromTo(
        `.${style.cloudHeader}`,
        { x: -550 },
        {
          x: 25,
          y: -10,
          duration: 1.5,
          opacity: 0.1,
          ease: Elastic.easeOut.config(1, 0.9),
        }
      )
      gsap.fromTo(
        `.${style.links}`,
        { x: 550, opacity: 0 },
        {
          x: 0,
          opacity: 1,
          duration: 1.5,
          stagger: 0.05,
          delay: 0.1,
          ease: Elastic.easeOut.config(1, 1),
        }
      )
      gsap.fromTo(
        `.${style.title}`,
        {
          x: 550,
          opacity: 0,
        },
        {
          y: -10,
          x: 0,
          opacity: 0.1,
          duration: 1.25,
          ease: Elastic.easeOut.config(1, 1),
        }
      )
    }, 70)
  }, [])

  // const showDesc = (ev) => {
  //   gsap.fromTo(
  //     `.navdesc${ev.target.id}`,
  //     { display: 'none', opacity: 0 },
  //     { display: 'block', opacity: 1, duration: 0.5 }
  //   )
  // }

  // const hideDesc = (ev) => {
  //   gsap.to(`.navdesc${ev.target.id}`, { display: 'none', opacity: 0, duration: 0.2 })
  // }

  return (
    <div ref={parentEle} className={style.pserv}>
      <div className={style.navboxleft} />
      <svg className={style.laserdivide} height={parentHeight * 0.7} viewBox="0 0 133 303">
        <defs>
          <linearGradient
            x1="49.2638145%"
            y1="84.9243045%"
            x2="50.7430252%"
            y2="16.3295925%"
            id="alasnav"
          >
            <stop stopColor="#1D8DBA" offset="0%" />
            <stop stopColor="#03ECAE" offset="100%" />
          </linearGradient>
          <filter
            x="-36.5%"
            y="-5.1%"
            width="173.1%"
            height="110.2%"
            filterUnits="objectBoundingBox"
            id="blasnav"
          >
            <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
          </filter>
          <filter
            x="-36.5%"
            y="-5.1%"
            width="173.1%"
            height="110.2%"
            filterUnits="objectBoundingBox"
            id="clasnav"
          >
            <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
          </filter>
        </defs>
        <g
          transform="translate(-9 4)"
          fill="url(#alasnav)"
          stroke="none"
          strokeWidth={1}
          fillRule="evenodd"
        >
          <path
            opacity={0.1}
            filter="url(#blasnav)"
            transform="rotate(-19 67.53 148.112)"
            d="M72.934082 1.5L47 63.9414063 75.0532227 148.112305 60.7143555 247.552734 86.8793945 294.724609 67.4077148 244.255859 88.059082 145.285156 52.262207 63.9414063z"
          />
          <path
            opacity={0.462692482}
            filter="url(#clasnav)"
            transform="rotate(-7 67.53 148.112)"
            d="M72.934082 1.5L47 63.9414063 75.0532227 148.112305 60.7143555 247.552734 86.8793945 294.724609 67.4077148 244.255859 88.059082 145.285156 52.262207 63.9414063z"
          />
          <path d="M72.934082 1.5L47 63.9414062 75.0532227 148.112305 60.7143555 247.552734 86.8793945 294.724609 67.4077148 244.255859 88.059082 145.285156 52.262207 63.9414062z" />
        </g>
      </svg>
      <div className={style.leftSideLinks}>
        <div className={style.cloudHeader}> By Cloud Platform </div>
        <Link
          to="/aws"
          onMouseOver={() => awsbutton('play')}
          onMouseLeave={() => awsbutton('stop')}
        >
          <svg className={style.cloudItem} width="280px" height="130px" viewBox="0 0 280 130">
            <defs>
              <path
                id="bawsnav"
                d="M20.8753568 3.26849658e-13L3.12638804e-13 48.116076 31.1558639 90.7682817 214.024395 82.1212869 243.264501 22.0189356 194.74036 6.46534821z"
              />
              <filter
                x="-14.4%"
                y="-27.5%"
                width="128.8%"
                height="177.1%"
                filterUnits="objectBoundingBox"
                id="aawsnav"
              >
                <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                  stdDeviation={10}
                  in="shadowOffsetOuter1"
                  result="shadowBlurOuter1"
                />
                <feColorMatrix
                  values="0 0 0 0 1 0 0 0 0 0.592156863 0 0 0 0 0 0 0 0 0.236013986 0"
                  in="shadowBlurOuter1"
                />
              </filter>
              <linearGradient
                x1="44.1644185%"
                y1="84.9243045%"
                x2="55.8897987%"
                y2="16.3295925%"
                id="cawsnav"
              >
                <stop stopColor="#F90" offset="0%" />
                <stop stopColor="#FFC671" offset="100%" />
              </linearGradient>
              <filter
                x="-77.8%"
                y="-30.7%"
                width="255.5%"
                height="161.3%"
                filterUnits="objectBoundingBox"
                id="dawsnav"
              >
                <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
              </filter>
            </defs>
            <g
              transform="translate(18 10)"
              stroke="none"
              strokeWidth={1}
              fill="none"
              fillRule="evenodd"
            >
              <use fill="#000" filter="url(#aawsnav)" xlinkHref="#bawsnav" />
              <use fill="#FFF" xlinkHref="#bawsnav" />
              <path
                fill="#FF9D00"
                opacity={0.15}
                d="M126.654487 3.76026574L133.308047 47.524598 116.63225 86.1670128 214.024395 82.1212869 243.264501 22.0189356 194.74036 6.46534821z"
              />
              <path
                className="awsarrow"
                fill="url(#cawsnav)"
                filter="url(#dawsnav)"
                d="M170.239289 71.6804403L179.749553 43.6681876 165.849596 22.7588539 185.136291 45.3077234z"
              />
              <path
                className="awsarrow"
                fill="url(#cawsnav)"
                d="M174.239289 67.6804403L183.749553 39.6681876 169.849596 18.7588539 189.136291 41.3077234z"
              />
              <g>
                <path
                  d="M20.826 15.978c0 .905.099 1.639.271 2.177.197.539.444 1.126.79 1.762.122.196.172.392.172.563 0 .244-.148.49-.469.734l-1.553 1.027c-.222.147-.444.22-.641.22-.247 0-.493-.122-.74-.342a7.576 7.576 0 01-.887-1.15c-.247-.416-.493-.88-.765-1.443-1.923 2.25-4.339 3.376-7.248 3.376-2.071 0-3.723-.587-4.931-1.762C3.616 19.966 3 18.4 3 16.443c0-2.08.74-3.769 2.244-5.04 1.504-1.273 3.5-1.91 6.04-1.91.839 0 1.701.074 2.614.196.912.123 1.849.318 2.835.539V8.44c0-1.86-.394-3.156-1.159-3.914-.789-.759-2.12-1.126-4.019-1.126a11.3 11.3 0 00-2.662.318c-.913.22-1.8.49-2.663.832a7.11 7.11 0 01-.863.318 1.523 1.523 0 01-.395.074c-.345 0-.517-.245-.517-.759V2.985c0-.391.049-.685.172-.856.124-.172.345-.343.69-.514.864-.44 1.9-.808 3.107-1.101C9.632.196 10.914.049 12.27.049c2.934 0 5.08.66 6.46 1.982 1.356 1.321 2.047 3.328 2.047 6.019v7.928h.049zm-10.01 3.719c.813 0 1.652-.147 2.54-.44.887-.294 1.676-.833 2.342-1.567.394-.464.69-.978.838-1.566a8.72 8.72 0 00.246-2.128v-1.028a20.732 20.732 0 00-2.268-.416 18.719 18.719 0 00-2.317-.147c-1.652 0-2.86.318-3.674.979-.814.66-1.208 1.59-1.208 2.814 0 1.15.296 2.006.912 2.593.592.612 1.455.906 2.589.906zm19.798 2.642c-.444 0-.74-.073-.937-.244-.197-.147-.37-.49-.517-.955L23.365 2.227c-.147-.49-.221-.808-.221-.98 0-.39.197-.61.591-.61h2.417c.468 0 .789.073.961.244.197.147.345.49.493.954l4.142 16.198 3.847-16.198c.123-.49.27-.807.468-.954.197-.147.543-.245.986-.245h1.973c.468 0 .789.074.986.245.197.147.37.49.468.954l3.896 16.394 4.265-16.394c.148-.49.32-.807.494-.954.197-.147.517-.245.961-.245h2.293c.395 0 .616.196.616.612 0 .122-.024.245-.049.391a3.46 3.46 0 01-.172.612l-5.942 18.914c-.148.49-.321.807-.518.954-.197.147-.518.245-.937.245h-2.12c-.469 0-.79-.074-.987-.245-.197-.171-.37-.49-.468-.979L37.986 5.36 34.19 21.116c-.123.49-.27.807-.468.979-.197.171-.543.244-.986.244h-2.12zM62.297 23c-1.282 0-2.565-.147-3.797-.44-1.233-.294-2.195-.612-2.836-.98-.394-.22-.665-.464-.764-.684a1.716 1.716 0 01-.148-.685v-1.248c0-.514.197-.759.567-.759.148 0 .296.025.444.074.148.049.37.146.616.244.839.367 1.75.661 2.712.857.987.195 1.948.293 2.934.293 1.554 0 2.762-.269 3.6-.807.838-.538 1.282-1.321 1.282-2.325 0-.685-.222-1.247-.666-1.712-.443-.465-1.282-.881-2.49-1.273l-3.575-1.1c-1.8-.564-3.131-1.395-3.945-2.496C55.418 8.882 55 7.683 55 6.41c0-1.028.221-1.933.665-2.716a6.306 6.306 0 011.775-2.007c.74-.562 1.578-.978 2.565-1.272C60.99.122 62.025 0 63.11 0c.543 0 1.11.024 1.652.098a27.25 27.25 0 011.603.269c.493.122.961.245 1.405.392.444.146.79.293 1.036.44.345.196.591.391.74.612.147.195.221.465.221.807v1.15c0 .514-.197.783-.567.783-.197 0-.518-.098-.937-.294-1.405-.636-2.983-.954-4.734-.954-1.405 0-2.514.22-3.279.685-.764.465-1.159 1.175-1.159 2.178 0 .685.247 1.272.74 1.737.493.465 1.405.93 2.712 1.346l3.501 1.101c1.775.563 3.058 1.346 3.822 2.349C70.63 13.702 71 14.852 71 16.124c0 1.053-.222 2.007-.641 2.839a6.592 6.592 0 01-1.8 2.153c-.764.612-1.676 1.052-2.737 1.37-1.11.343-2.268.514-3.525.514z"
                  fill="#252F3E"
                  fillRule="nonzero"
                  transform="translate(24.393 24)"
                />
                <g fill="#F90">
                  <path
                    d="M66.772 7.675c-8.062 6.075-19.775 9.3-29.846 9.3C22.813 16.975 10.096 11.65.49 2.8c-.76-.7-.073-1.65.833-1.1 10.39 6.15 23.205 9.875 36.461 9.875 8.944 0 18.77-1.9 27.811-5.8 1.348-.625 2.5.9 1.177 1.9z"
                    transform="translate(24.393 24) translate(0 27)"
                  />
                  <path
                    d="M70.128 3.775c-1.029-1.35-6.811-.65-9.433-.325-.784.1-.907-.6-.196-1.125 4.606-3.3 12.178-2.35 13.06-1.25.882 1.125-.245 8.85-4.558 12.55-.661.575-1.298.275-1.004-.475.98-2.475 3.16-8.05 2.131-9.375z"
                    transform="translate(24.393 24) translate(0 27)"
                  />
                </g>
              </g>
            </g>
          </svg>
        </Link>

        <Link
          to="/google"
          onMouseOver={() => gcpbutton('play')}
          onMouseLeave={() => gcpbutton('stop')}
        >
          <svg className={style.cloudItem} width="261px" height="132px" viewBox="0 0 261 132">
            <defs>
              <path
                id="bgoog"
                d="M21.4821462 0.231718336L0.606789436 48.3477944 31.7626534 91 204.631184 92.3530052 224.155115 44.1741252 207.792338 0.649196973z"
              />
              <filter
                x="-15.7%"
                y="-27.1%"
                width="131.3%"
                height="176.0%"
                filterUnits="objectBoundingBox"
                id="agoog"
              >
                <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                  stdDeviation={10}
                  in="shadowOffsetOuter1"
                  result="shadowBlurOuter1"
                />
                <feColorMatrix
                  values="0 0 0 0 0.925490196 0 0 0 0 0.243137255 0 0 0 0 0.168627451 0 0 0 0.217466128 0"
                  in="shadowBlurOuter1"
                />
              </filter>
              <linearGradient
                x1="44.1644185%"
                y1="84.9243045%"
                x2="55.8897987%"
                y2="16.3295925%"
                id="cgoog"
              >
                <stop stopColor="#EC3E2B" offset="0%" />
                <stop stopColor="#F94E3C" offset="100%" />
              </linearGradient>
              <filter
                x="-77.8%"
                y="-30.7%"
                width="255.5%"
                height="161.3%"
                filterUnits="objectBoundingBox"
                id="dgoog"
              >
                <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
              </filter>
            </defs>
            <g
              transform="translate(18 9)"
              stroke="none"
              strokeWidth={1}
              fill="none"
              fillRule="evenodd"
            >
              <g transform="translate(0 .768)">
                <use fill="#000" filter="url(#agoog)" xlinkHref="#bgoog" />
                <use fill="#FFF" xlinkHref="#bgoog" />
                <path
                  fill="#EC3F2B"
                  opacity={0.15}
                  d="M123.737315 0.651595825L149.688476 46.5011011 133.789221 92 204.631184 92.3530052 224.155115 44.1741252 207.792338 0.649196973z"
                />
              </g>
              <path
                className="gcparrow"
                fill="url(#cgoog)"
                filter="url(#d)"
                d="M171.846079 70.6804403L181.356343 42.6681876 167.456385 21.7588539 186.74308 44.3077234z"
              />
              <path
                className="gcparrow"
                fill="url(#cgoog)"
                d="M175.846079 66.6804403L185.356343 38.6681876 171.456385 17.7588539 190.74308 40.3077234z"
              />
              <g fillRule="nonzero">
                <path
                  d="M54.783 7.715l1.03.018 2.797-2.797.135-1.186a12.525 12.525 0 00-8.35-3.18C44.6.57 39.707 4.513 38.258 9.856c.306-.213.959-.054.959-.054l5.59-.92s.288-.477.432-.447a6.984 6.984 0 019.545-.72h-.001z"
                  fill="#EA4335"
                  transform="translate(25 18)"
                />
                <path
                  d="M62.55 9.866a12.591 12.591 0 00-3.794-6.117l-3.962 3.962a6.975 6.975 0 012.605 5.435v.7a3.496 3.496 0 013.492 3.492A3.499 3.499 0 0157.4 20.83h-6.986l-.699.702v4.192l.7.695h6.985a9.099 9.099 0 009.075-9.08 9.096 9.096 0 00-3.933-7.473h.009z"
                  fill="#4285F4"
                  transform="translate(25 18)"
                />
                <path
                  d="M43.41 26.426h6.985v-5.591H43.41c-.496 0-.987-.106-1.438-.312l-1.008.308-2.797 2.798-.245.945a8.964 8.964 0 005.488 1.854v-.002z"
                  fill="#34A853"
                  transform="translate(25 18)"
                />
                <path
                  d="M43.41 8.258a9.099 9.099 0 00-9.084 9.084 9.072 9.072 0 003.6 7.236l4.05-4.05a3.492 3.492 0 114.617-4.617l4.05-4.05a9.069 9.069 0 00-7.236-3.6l.004-.003z"
                  fill="#FBBC05"
                  transform="translate(25 18)"
                />
                <path
                  d="M7.2 44.043c-1.908 0-3.546-.675-4.927-2.025-1.38-1.35-2.07-2.973-2.07-4.867 0-1.894.689-3.517 2.07-4.867 1.382-1.35 3.022-2.026 4.927-2.026a6.588 6.588 0 014.724 1.899l-1.33 1.33A4.788 4.788 0 007.2 32.14c-1.377 0-2.547.486-3.506 1.464a4.869 4.869 0 00-1.438 3.547c0 1.391.477 2.571 1.438 3.546a4.725 4.725 0 003.506 1.464c1.402 0 2.56-.45 3.483-1.38.54-.54.9-1.35 1.026-2.372H7.203v-1.883h6.34c.067.335.09.72.09 1.17 0 1.85-.543 3.318-1.632 4.406-1.235 1.291-2.835 1.935-4.81 1.935l.009.005zm14.733-1.26c-.864.846-1.917 1.26-3.16 1.26-1.245 0-2.3-.423-3.162-1.26-.862-.837-1.294-1.901-1.294-3.168 0-1.266.432-2.322 1.294-3.168.863-.846 1.917-1.26 3.161-1.26s2.299.423 3.161 1.26c.862.837 1.294 1.905 1.294 3.168 0 1.264-.432 2.322-1.294 3.168zm-4.927-1.242a2.367 2.367 0 001.767.764c.684 0 1.273-.253 1.767-.765.494-.51.74-1.152.74-1.926 0-.783-.243-1.429-.732-1.935a2.371 2.371 0 00-1.775-.756 2.376 2.376 0 00-1.775.756c-.488.504-.731 1.149-.731 1.935 0 .773.245 1.416.74 1.926v.001zm14.646 1.242c-.864.846-1.917 1.26-3.16 1.26-1.245 0-2.3-.423-3.162-1.26-.862-.837-1.294-1.901-1.294-3.168 0-1.266.432-2.322 1.294-3.168.863-.846 1.918-1.26 3.161-1.26 1.244 0 2.299.423 3.161 1.26.862.837 1.294 1.905 1.294 3.168 0 1.264-.432 2.322-1.294 3.168zm-4.927-1.242a2.367 2.367 0 001.767.764c.684 0 1.273-.253 1.767-.765.494-.51.74-1.152.74-1.926 0-.783-.243-1.429-.732-1.935a2.371 2.371 0 00-1.775-.756 2.376 2.376 0 00-1.775.756c-.488.504-.731 1.149-.731 1.935 0 .773.245 1.416.74 1.926v.001zm11.316 6.498c-.985 0-1.815-.264-2.487-.792-.673-.527-1.154-1.137-1.446-1.834l1.7-.705c.178.427.45.797.84 1.111.389.314.845.47 1.396.47.74 0 1.321-.225 1.74-.672.418-.448.63-1.095.63-1.935v-.63h-.068c-.54.672-1.33 1.01-2.336 1.01-1.133 0-2.124-.433-2.977-1.295a4.284 4.284 0 01-1.278-3.128 4.338 4.338 0 011.278-3.153c.85-.867 1.845-1.302 2.977-1.302.504 0 .96.094 1.37.286.408.192.731.427.966.705h.068v-.715h1.85v7.971c0 1.548-.394 2.704-1.186 3.474-.792.765-1.802 1.152-3.036 1.152v-.018zm.135-5.735c.65.012 1.27-.268 1.691-.764.454-.51.68-1.145.68-1.91 0-.772-.226-1.418-.68-1.934a2.16 2.16 0 00-1.69-.773c-.685 0-1.268.26-1.749.773-.48.513-.723 1.159-.723 1.935 0 .761.24 1.4.723 1.91.484.51 1.065.764 1.748.764zm7.382-11.578v13.05h-1.95v-13.05h1.95zm5.346 13.316c-1.256 0-2.304-.426-3.145-1.278-.84-.851-1.261-1.904-1.261-3.16 0-1.3.405-2.367 1.218-3.195a4.005 4.005 0 012.968-1.246c.538 0 1.038.097 1.497.294.427.175.815.432 1.143.756.274.273.516.574.724.9.171.277.318.57.437.874l.203.504-5.935 2.459c.45.896 1.17 1.345 2.153 1.345.896 0 1.626-.407 2.185-1.226l1.512 1.01c-.337.504-.813.958-1.43 1.361-.616.404-1.374.603-2.27.603h.001zm-2.471-4.572l3.96-1.647c-.114-.28-.319-.507-.63-.68a2.034 2.034 0 00-1.026-.26c-.573 0-1.107.235-1.605.706-.498.47-.738 1.1-.716 1.882h.017zm16.497 4.572c-1.773 0-3.258-.599-4.457-1.8-1.199-1.2-1.8-2.695-1.8-4.489s.6-3.29 1.8-4.489c1.2-1.199 2.684-1.8 4.457-1.8 1.815 0 3.29.657 4.421 1.967l-1.075 1.044c-.81-1.021-1.935-1.53-3.348-1.53-1.314 0-2.418.442-3.33 1.329-.913.886-1.354 2.045-1.354 3.48 0 1.434.45 2.595 1.354 3.482.903.888 2.01 1.33 3.33 1.33 1.445 0 2.68-.584 3.69-1.748l1.075 1.075a5.859 5.859 0 01-2.07 1.572c-.847.39-1.77.588-2.703.578h.01zm7.7-.266h-1.548v-12.04h1.548v12.04zm2.523-7.254c.796-.834 1.8-1.254 3.043-1.254 1.244 0 2.248.419 3.044 1.254.797.835 1.195 1.89 1.195 3.136 0 1.247-.396 2.302-1.195 3.137-.798.835-1.8 1.254-3.043 1.254-1.244 0-2.248-.419-3.044-1.254-.797-.835-1.195-1.89-1.195-3.137 0-1.246.396-2.3 1.195-3.136zm1.152 5.295c.54.542 1.164.815 1.89.815.725 0 1.35-.273 1.89-.815.54-.543.799-1.265.799-2.16 0-.896-.267-1.618-.8-2.16-.531-.542-1.164-.816-1.89-.816-.725 0-1.35.273-1.89.816-.54.542-.799 1.264-.799 2.16 0 .895.268 1.618.8 2.16zm14.688 1.959h-1.48v-1.143h-.068c-.234.392-.594.726-1.076.99-.481.264-.99.414-1.53.414-1.032 0-1.812-.313-2.344-.942-.532-.63-.8-1.47-.8-2.523v-5.045h1.549v4.791c0 1.537.677 2.304 2.034 2.304a1.89 1.89 0 001.564-.772c.4-.507.613-1.137.605-1.783v-4.54h1.547v8.24l-.001.009zm5.245.267c-1.065 0-1.986-.42-2.758-1.261s-1.159-1.883-1.159-3.129c0-1.245.387-2.288 1.16-3.128.772-.84 1.693-1.262 2.757-1.262.626 0 1.192.135 1.692.402s.873.605 1.119 1.01h.067l-.067-1.143v-3.798h1.548v12.042h-1.48v-1.143h-.068c-.246.402-.619.74-1.12 1.01-.499.264-1.064.4-1.691.4zm.252-1.413a2.466 2.466 0 001.858-.807c.51-.537.765-1.262.765-2.16 0-.898-.253-1.632-.765-2.16a2.466 2.466 0 00-1.858-.807c-.718 0-1.335.272-1.85.815-.516.543-.773 1.265-.773 2.16 0 .896.257 1.618.772 2.16a2.457 2.457 0 001.85.816v-.017z"
                  fill="#5F6368"
                  transform="translate(25 18)"
                />
              </g>
            </g>
          </svg>
        </Link>

        <Link
          to="/azure"
          onMouseOver={() => azurebutton('play')}
          onMouseLeave={() => azurebutton('stop')}
        >
          <svg className={style.cloudItem} width="268px" height="132px" viewBox="0 0 268 132">
            <defs>
              <path
                id="bazure"
                d="M0 9.64699216L0 51.1705866 31.1558639 93.8227922 212.87129 93.8227922 230 43.3211461 192.260167 9.64699216 24.8002582 0.791733874z"
              />
              <filter
                x="-15.2%"
                y="-26.9%"
                width="130.4%"
                height="175.2%"
                filterUnits="objectBoundingBox"
                id="aazure"
              >
                <feOffset dy={10} in="SourceAlpha" result="shadowOffsetOuter1" />
                <feGaussianBlur
                  stdDeviation={10}
                  in="shadowOffsetOuter1"
                  result="shadowBlurOuter1"
                />
                <feColorMatrix
                  values="0 0 0 0 0 0 0 0 0 0.541176471 0 0 0 0 0.850980392 0 0 0 0.15 0"
                  in="shadowBlurOuter1"
                />
              </filter>
              <filter
                x="-77.8%"
                y="-30.7%"
                width="255.5%"
                height="161.3%"
                filterUnits="objectBoundingBox"
                id="cazure"
              >
                <feGaussianBlur stdDeviation={5} in="SourceGraphic" />
              </filter>
            </defs>
            <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
              <g transform="translate(20 9)">
                <use fill="#000" filter="url(#aazure)" xlinkHref="#bazure" />
                <use fill="#FFF" xlinkHref="#bazure" />
                <path
                  fill="#008AD8"
                  opacity={0.2}
                  d="M159.099733 47.307263L139.519964 94.2411461 212.87129 93.8227922 230 43.3211461 192.260167 9.64699216 126 5.64699216z"
                />
                <path
                  className="azurearrow"
                  fill="#008AD9"
                  filter="url(#cazure)"
                  d="M180.846079 80.9215864L190.356343 52.9093337 176.456385 32 195.74308 54.5488694z"
                />
                <path
                  className="azurearrow"
                  fill="#008AD9"
                  d="M184.846079 76.9215864L194.356343 48.9093337 180.456385 28 199.74308 50.5488694z"
                />
              </g>
              <path
                d="M17.035 27.451l8.683-1.562.082-.018-4.467-5.402c-2.456-2.97-4.466-5.413-4.466-5.427 0-.027 4.612-12.94 4.638-12.986.009-.015 3.147 5.494 7.608 13.356 4.176 7.36 7.62 13.428 7.651 13.485l.059.103-14.195-.002-14.194-.002 8.601-1.545zm54.434-1.306c-2.16-.141-3.417-1.392-3.75-3.734-.088-.622-.089-.639-.098-4.682l-.009-3.914H69.525l.007 3.785c.007 3.412.011 3.812.044 4.052.13.974.389 1.63.83 2.1.353.376.767.596 1.34.713.27.055 1.037.055 1.283 0a2.825 2.825 0 001.456-.803c.468-.475.813-1.15.98-1.912l.057-.257.007-3.818.006-3.817h1.952V25.86h-1.932v-.952c0-.647-.007-.95-.022-.945a.783.783 0 00-.11.172 3.961 3.961 0 01-1.496 1.522c-.728.408-1.46.553-2.458.488zm21.932-.01a5.009 5.009 0 01-2.223-.738c-1.383-.87-2.202-2.304-2.441-4.278-.083-.683-.093-1.6-.024-2.18.155-1.298.656-2.57 1.37-3.48.182-.233.597-.655.827-.84a5.117 5.117 0 012.11-1.025 6.75 6.75 0 011.712-.102 4.478 4.478 0 013.035 1.585c.756.915 1.172 2.193 1.225 3.767.008.247.01.68.005.962l-.011.512-4.185.006-4.185.005v.19c0 .578.138 1.236.377 1.797.206.483.56 1.01.85 1.266a3.71 3.71 0 002.123.912 8.139 8.139 0 001.386-.054 5.824 5.824 0 002.614-1.097c.087-.066.17-.128.185-.137.021-.014.026.159.026.886l-.001.903-.198.125a6.852 6.852 0 01-2.804.988c-.303.038-1.412.055-1.773.027zm3.642-7.62c0-.968-.401-2.043-.97-2.597a2.646 2.646 0 00-1.477-.729 4.295 4.295 0 00-1.147.033c-.614.126-1.122.4-1.565.846a4.348 4.348 0 00-1.036 1.686c-.08.233-.172.616-.2.829l-.014.101H97.043v-.168zm-56.772 7.319l3.158-8.436 3.15-8.41H48.602l.084.219c.257.669 6.305 16.635 6.305 16.644 0 .005-.484.01-1.076.01h-1.077l-.872-2.36-.871-2.36h-7.02l-.03.08c-.017.044-.39 1.105-.828 2.36l-.797 2.279h-1.08c-.853 0-1.076-.005-1.069-.026zm10.183-6.494c0-.004-.587-1.621-1.304-3.594-1.341-3.69-1.416-3.912-1.522-4.505-.05-.278-.075-.285-.104-.032a5.975 5.975 0 01-.183.812c-.035.111-.64 1.797-1.343 3.746a585.387 585.387 0 00-1.278 3.561c0 .01 1.29.018 2.867.018a303.7 303.7 0 002.867-.006zm5.188 6.213v-.307l3.497-4.888 3.497-4.888-3.166-.01-3.166-.011-.006-.817-.005-.817H65.452v.552l-3.498 4.914c-1.923 2.703-3.497 4.92-3.497 4.925 0 .005 1.555.01 3.455.01h3.456v1.644h-9.726v-.307zm25.661.293a654.18 654.18 0 01-.014-6.023v-6.008h1.912v1.239c0 .68.008 1.238.018 1.238.01 0 .056-.111.103-.248a4.29 4.29 0 011.068-1.672 2.75 2.75 0 011.51-.763c.164-.027.302-.032.63-.023.412.01.627.041.877.124l.079.027v2.017l-.226-.115a2.378 2.378 0 00-1.266-.258c-.307.016-.51.056-.756.15a2.401 2.401 0 00-1.204 1 5.875 5.875 0 00-.8 2.337c-.015.143-.024 1.307-.028 3.602l-.006 3.39h-.941c-.518 0-.948-.006-.956-.014zM0 25.804c0-.008 2.105-3.722 4.677-8.255l4.677-8.24 5.45-4.651C17.8 2.1 20.262.004 20.272 0c.01-.004-.03.097-.088.224l-5.918 12.907-5.813 12.676-4.226.005c-2.325.003-4.227 0-4.227-.008z"
                transform="translate(20 9) translate(30 28)"
                fill="#0089D6"
                fillRule="nonzero"
              />
            </g>
          </svg>
        </Link>
      </div>

      <div className={style.rightSideLinks}>
        <div className={style.bySpecialty}>
          <div className={style.title}>By Specialty</div>
          <ul className={style.linksContainer}>
            {menu.map((item, key) => (
              <li className={style.links} key={`url:${item.href}`}>
                <div className={style.listItem}>
                  <Link to={item.href}>{getIcon(item.label)}</Link>
                  <div>
                    <Link to={item.href} className={style.link} id={key}>
                      {item.label}
                    </Link>
                    <Link to={item.href} className={clsx(style.description, `navdesc${key}`)}>
                      {item.description}
                    </Link>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}

ProServiceMenu.propTypes = {
  parentw: PropTypes.string.isRequired,
  parenth: PropTypes.string.isRequired,
}

export default ProServiceMenu
